import * as React from "react";
import { useEffect } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import { SPA } from "./SPA/SPA.tsx";
import { Pricing } from "./Pages/Pricing/Pricing.tsx";
import NotFound from "./Components/NotFound/NotFound.tsx";

// Scrolls to the #hash target after route changes (e.g. /#contact from /pricing),
// and back to the top on plain route changes.
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

// GA4 — loads only when REACT_APP_GA_ID is set, and reports SPA route changes.
const Analytics = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const id = process.env.REACT_APP_GA_ID;
    if (!id) return;
    if (!window.gtag) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", id, { send_page_view: false });
    }
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
    });
  }, [pathname, search]);
  return null;
};

const app = (
  <BrowserRouter basename="/">
    <ScrollManager />
    <Analytics />
    <Routes>
      <Route path="/" element={<SPA />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

const rootEl = document.getElementById("root");
// Prerendered pages (scripts/prerender.js) ship real HTML — hydrate it.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
